import React from "react";
import { Search } from "lucide-react";
import CategoryCard from "./CategoryCard";

const ReportsControlPanel = ({
  searchTerm, setSearchTerm,
  categories, selectedCategory, setSelectedCategory,
  styles, text, language, screenSize
}) => {
  return (
    <div style={styles.controlPanel}>

      {/* Search */}
      <div style={{
        padding: "clamp(16px, 3vw, 24px)",
        paddingBottom: 0,
      }}>
        <div style={{
          position: "relative",
          maxWidth: "480px",
        }}>
          <Search
            size={screenSize.isMobile ? 16 : 18}
            style={{
              position: "absolute",
              left: language === "ar" ? "auto" : "14px",
              right: language === "ar" ? "14px" : "auto",
              top: "50%",
              transform: "translateY(-50%)",
              color: "rgba(148,163,184,0.8)",
              pointerEvents: "none",
            }}
          />
          <input
            type="text"
            placeholder={text[language].searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              ...styles.searchInput,
              paddingLeft: language === "ar" ? "16px" : "42px",
              paddingRight: language === "ar" ? "42px" : "16px",
              height: "44px",
              borderRadius: "12px",
              fontSize: "14px",
              width: "100%",
              boxSizing: "border-box",
            }}
          />
        </div>
      </div>

      {/* Divider */}
      <div style={{
        height: "1px",
        margin: "clamp(12px, 2vw, 20px) clamp(16px, 3vw, 24px) 0",
        background: "rgba(148,163,184,0.1)",
      }} />

      {/* Categories */}
      <div style={{
        padding: "clamp(12px, 2vw, 16px) clamp(16px, 3vw, 24px)",
        paddingBottom: "clamp(16px, 3vw, 24px)",
      }}>
        <div style={{
          display: "flex",
          gap: "clamp(8px, 1.5vw, 12px)",
          overflowX: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          paddingBottom: "4px",
        }}>
          {categories.map((category) => (
            <CategoryCard
              key={category.id}
              category={category}
              isSelected={selectedCategory === category.id}
              onClick={() => setSelectedCategory(category.id)}
              styles={styles}
              screenSize={screenSize}
            />
          ))}
        </div>
      </div>

    </div>
  );
};

export default ReportsControlPanel;